import React from "react";
import Slider from "react-slick";
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Custom Arrow Components
const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow next" onClick={onClick}>
      <AiOutlineRight size={20} />
    </div>
  );
};

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow prev" onClick={onClick}>
      <AiOutlineLeft size={20} />
    </div>
  );
};

const HeroSection = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className="slider-container overflow-hidden">
      <Slider {...settings}>
        {/* <div className="slide-content">
          <img
            // src="/images/HeroSection/1762505629229.jpg"
            src="/images/HeroSection/lifeinsuranceFinalist.jpg"
            className="slide-image"
            style={{ background: "#71C3CE" }}  
            alt="Insurance Illustration"
          />   
        </div> */}
        <div className="slide-content">
          <img
            src="/images/HeroSection/heart1 (1).jpg"
            className="slide-image"
            style={{ background: "#71C3CE" }}
            alt="Insurance Illustration"
          />
        </div>
    
        <div className="slide-content">
          <img
            src="/images/HeroSection/life-insurance_Finalist.jpg"
            className="slide-image"
            style={{ background: "#71C3CE" }}
            alt="Insurance Illustration"
          />
        </div>
          <div className="slide-content" style={{backgroundColor: 'red'}}>
          <img
            src="/images/HeroSection/Screenshot 2025-11-08 224613.png"
            className="slide-image"
            style={{ background: "#71C3CE" }}
            alt="Insurance Illustration"
          />
        </div>
      </Slider>
    </div>
  );
};

export default HeroSection;
